"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPagination = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PaginationMixin = require("../../mixins/components/PaginationMixin");
var StyledPagination = /*#__PURE__*/_styledComponents.default.nav.withConfig({
  displayName: "StyledPagination",
  componentId: "c11n-8-107-0__sc-4uav85-0"
})(["", ""], _PaginationMixin.PaginationMixin);
exports.StyledPagination = StyledPagination;